import { Button } from "antd";
import React from "react";

const CommentButton = ({
  htmlType = "",
  onChange,
  style,
  children,
  loading,
  onClick,
}: {
  htmlType?: string;
  onChange?: any;
  style?: React.CSSProperties | undefined;
  children?: any;
  loading?: boolean;
  onClick?: any;
}) => {
  const styles = {
    btn_submit: {
      background: "#d72229",
      cursor: "pointer",
      color: "#fff",
      padding: "8px 16px",
      fontSize: "12px",
      borderRadius: "4px",
      width: "100%",
      lineHeight: "15px",
      height: "34px",
    },
    btn_cancle: {
      backgroundColor: "#fff",
      color: "#000",
      cursor: "pointer",
      padding: "8px 16px",
      fontSize: "12px",
      borderRadius: "4px",
      width: "100%",
      height: "34px",
      lineHeight: "15px",
    },
  };

  switch (htmlType) {
    case "submit":
      return (
        <Button
          loading={loading ? loading : false}
          htmlType="submit"
          style={{ ...styles.btn_submit, textTransform: "none" }}
        >
          {children}
        </Button>
      );
    default:
      return (
        <Button
          style={{
            ...styles.btn_cancle,
            textTransform: "none",
          }}
          onClick={onClick}
        >
          {children}
        </Button>
      );
  }
};

export default CommentButton;
